import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ResultData } from 'src/app/_models/ResultData';
import { AdminService } from 'src/app/_services/admin.service';
import { RoleGroupService } from 'src/app/_services/role-group.service';

@Component({
  selector: 'app-user-list-by-role',
  templateUrl: './user-list-by-role.component.html',
  styleUrls: ['./user-list-by-role.component.css']
})
export class UserListByRoleComponent implements OnInit {

  users =undefined
  roleGroup = {}
  dtOptions: DataTables.Settings = {}
  isLoading = true
  server_role_group_id=0
  constructor(private adminService:AdminService, private activeRoute:ActivatedRoute, private roleGroupService:RoleGroupService) { }

  ngOnInit(): void {
   this.isLoading = true
    this.dtOptions = {
      pagingType: 'full_numbers'
     };
     this.activeRoute.params.subscribe(
      xx=>{
      this.server_role_group_id=xx['server_role_group_id']
      this.getRoleGroupName(this.server_role_group_id)
        this.fetchUsers()
      }
     )
  }



fetchUsers(){
    this.adminService.getUsersByRole(this.server_role_group_id).subscribe(
    { next:(x:ResultData)=>{
      this.users=x.rs.data
      this.isLoading=false
    }
  }
  )
}

getRoleGroupName(role_group_id:number){
this.roleGroupService.getRoleGroupName(role_group_id).subscribe(
  {next:(x:ResultData)=>{
    this.roleGroup= x.rs.data
  }
}
)
  }
  addUserToRoleGroup(permissionId: number): void {
    this.isLoading = true;
    let data = new URLSearchParams();
    data.set('server_role_id', permissionId.toString());
    data.set('server_role_group_id', this.roleGroup['id']);
    this.roleGroupService.addUserToRoleGroup( data.toString()).subscribe({
      next: (x:ResultData) => {
        this.users=x.rs.data
        this.isLoading = false;
      },
      error: (err) => {
        console.error(`Error adding permission with ID ${permissionId} to RoleGroup`, err);
        this.isLoading = false;
      }
    });
  }
  removeUserFromRoleGroup(permissionId: number): void {
    this.users = true;
    let data = new URLSearchParams();
        data.set('server_role_id', permissionId.toString());
        data.set('server_role_group_id', this.roleGroup['id']);
    this.roleGroupService.removeUserFromRoleGroup(data.toString()).subscribe({
      next: (x:ResultData) => {
        this.users=x.rs.data
        this.isLoading = false;
      },
      error: (err) => {
        console.error(`Error adding permission with ID ${permissionId} to RoleGroup`, err);
        this.isLoading = false;
      }
    });
  }


}
